import { render, staticRenderFns } from "./shop_detial.vue?vue&type=template&id=439bfe84&scoped=true"
import script from "./shop_detial.vue?vue&type=script&lang=js"
export * from "./shop_detial.vue?vue&type=script&lang=js"
import style0 from "./shop_detial.vue?vue&type=style&index=0&id=439bfe84&prod&scoped=true&lang=less"
import style1 from "./shop_detial.vue?vue&type=style&index=1&id=439bfe84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439bfe84",
  null
  
)

export default component.exports